<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">

    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12">
            <m-card >
              <ng-container mCardHeaderTitle>
             <b>   Yeni Rapor Oluştur</b>
              </ng-container>
              <ng-container mCardBody>
                <div class="row mb-2">

                  <div class="col-md-12">
                    <form [formGroup]="definitionForm">


                      <div class="row">
                        <div class="col-md-3">
                          <label>Rapor Dili</label>
                          <select class="form-control" formControlName="language"
                            (change)="onChange($event.target.value)">

                            <option value="1">Türkçe</option>
                            <option value="2">İngilizce</option>
                          </select>

                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                          <label>Ürün Grubu</label>
                           <ng-select [items]="categories" [searchable]="true" bindLabel="name"
                     placeholder="Ürün Grubu Seçiniz" [(ngModel)]="selectedCategory" [ngModelOptions]="{standalone: true}" (change)="selectcat($event)">
                   </ng-select>
                         </div>
                        </div>
                         <div class="col-md-3">
                          <div class="form-group">
                            <label>
                              Durulanan-Durulanmayan
                            </label>

                            <select class="form-control" formControlName="durulanan">
                              <option value="0.01">Durulanan</option>
                              <option value="1">Durulanmayan</option>
                              <option value="0.1">Bekletilip Durulanan</option>
                            
                            </select>
                          </div>
                         </div>
                         <div class="col-md-3">
                          <div class="form-group">
                            <label>
                              Hedef Kitle
                            </label>

                            <select class="form-control" formControlName="age">
                              <option value="100">Yetişkin</option>
                              <option value="130">10 yaşına kadar</option>
                              <option value="150">5 yaşına kadar</option>
                              <option value="160">12 aylık olana kadar</option>
                              <option value="180">6 aylık olana kadar</option>
                              <option value="230">Yeni doğan</option>
                            </select>
                          </div>
                         </div>
                        </div>



                        <div class="row mt-3">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Ürün Adı</label>
                              <input type="text" formControlName="name" class="form-control">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Ürün Fonksiyonu</label>
                              <input type="text" formControlName="functionName" class="form-control">
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Sorumlu Kişi</label>
                              <input type="text" formControlName="authorizedPersonel" class="form-control">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Adres</label>
                              <input type="text" formControlName="address" class="form-control">
                            </div>
                          </div>
                        </div>


                    
                      <div class="row mt-5">
                        <div class="col-md-12">
                          <h3><b>KOZMETİK ÜRÜNLERDE GÜVENLİLİK DEĞERLENDİRME RAPORU</b></h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label><b> Kısım A: Kozmetik Ürün Güvenlilik Bilgileri </b></label>
                            <ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editor" formControlName="parta">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>



                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label><b> Kısım B: Kozmetik Ürün Güvenlilik Değerlendirmesi </b></label>
                            <ngx-editor-menu [editor]="editorb" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editorb" formControlName="partb">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>

                     

                      <div class="row">
                        <div class="col-md-12">
                          <h3><b>1) Kozmetik Ürünün Kantitatif ve Kalitatif Bileşimi</b></h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                         <h3>Hammadde/Bileşik Seçimi</h3>
                        </div>
                        <div class="col-md-4">
                          <select class="form-control" [(ngModel)]="elementType" [ngModelOptions]="{standalone: true}">
                            <option value="1">Hammadde</option>
                            <option value="2">Bileşik</option>
                          </select>
                        </div>
                      </div>

                      <div class="row mt-3" *ngIf="elementType=='2'">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Bileşik Adı</label>
                            <ng-template #rt let-r="result" let-t="term">

                              <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                            </ng-template>
                            <input id="typeahead-http" type="text" class="form-control"
                              [class.is-invalid]="searchFailed" [(ngModel)]="madde" [ngbTypeahead]="search"
                              [resultTemplate]="rt" placeholder="Hammadde ara" [inputFormatter]="formatter"
                              [ngModelOptions]="{standalone: true}" />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>
                              Konsantrasyon
                            </label>
                            <input type="text" class="form-control" [(ngModel)]="konsantrasyon"
                              [ngModelOptions]="{standalone: true}">
                          </div>
                        </div>
                        <div class="col-md-2">
                          <button class="btn btn-success mt-2" (click)="addMadde()">Ekle</button>
                        </div>
                      </div>

                      <div class="row mt-3" *ngIf="elementType=='1'">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Hammadde Adı</label>
                            <ng-template #rt2 let-r="result" let-t="term">

                              <ngb-highlight [result]="r.inciName" [term]="t"></ngb-highlight>
                            </ng-template>
                            <input id="typeahead-http1" type="text" class="form-control"
                              [class.is-invalid]="searchFailed2" [(ngModel)]="madde2" [ngbTypeahead]="search2"
                              [resultTemplate]="rt2" placeholder="Hammadde ara" [inputFormatter]="formatter2"
                              [ngModelOptions]="{standalone: true}" />
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>
                              %Hm
                            </label>
                            <input type="text" class="form-control" [(ngModel)]="hm"
                              [ngModelOptions]="{standalone: true}">
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>
                              Konsantrasyon
                            </label>
                            <input type="text" class="form-control" [(ngModel)]="konsantrasyon"
                              [ngModelOptions]="{standalone: true}">
                          </div>
                        </div>
                        <div class="col-md-2">
                          <button class="btn btn-success mt-2" (click)="addMadde2()">Ekle</button>
                        </div>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-12">
                          <div class="table-responsive">
                          <table class="table table-bordered">
                            <thead>
                  <tr>
                    <th>Hammadde/Kimyasal (Ticari) Adı</th>
                    <th>INCI Adı</th>
                    <th>CAS</th>
                    <th>EINECS/ELICS</th>
                    <th>Fonksiyon</th>
                    <th>Noeal</th>
                    <th>% HM</th>
                    <th>% BU</th>
                    <th>Konsantrasyon</th>
                    <th>İşlemler</th>
                  </tr>
                </thead>

                            <tbody>

                               <ng-container *ngFor="let item of compounds;index as i">
                  <tr class="main-row">
                    <td class="align-middle" [attr.rowspan]="item.madde.materials.length">{{ item.madde.name }}</td>
                    <td>{{ item.madde.materials[0].material.inciName }}</td>
                    <td>{{item.madde.materials[0].material.cas}}</td>
                    <td>{{item.madde.materials[0].material.einecs}}</td>
                    <td>{{item.madde.materials[0].material.function}}</td>
                    <td>{{item.madde.materials[0].material.noael}}  <i class="fa fa-edit primary" (click)="openEditModal(item.madde.materials[0].material)"></i></td>
                    <td>{{item.madde.materials[0].hm}}</td>
                    <td>{{item.madde.materials[0].bu}}</td>
                    <td class="align-middle" [attr.rowspan]="item.madde.materials.length">
                     {{item.consantration}}
                    </td>
                    <td class="align-middle" [attr.rowspan]="item.madde.materials.length">
                       <i class="la la-trash danger" (click)="removeMadde(i)"></i>
                    </td>
                  </tr>
                  <tr *ngFor="let cat of item.madde.materials.slice(1)">
                    <td>{{ cat.material.inciName }}</td>
                    <td>{{cat.material.cas}}</td>
                    <td>{{cat.material.einecs}}</td>
                    <td>{{cat.material.function}}</td>
                    <td>{{cat.material.noael}}  <i class="fa fa-edit primary" (click)="openEditModal(item.madde.materials[0].material)"></i></td>
                    <td>{{cat.hm}}</td>
                    <td>{{cat.bu}}</td>
                   
                  
                  </tr>
                </ng-container>
                              <!-- <tr *ngFor="let c of compounds;index as i">
                                <td>
                                  {{
                                    c.madde.name
                                  }}
                                </td>
                                <td>
                                  {{
                                    c.consantration
                                  }}
                                </td>
                                <td>

                                  <i class="la la-trash danger" (click)="removeMadde(i)"></i>
                                </td>
                              </tr> -->
                            </tbody>
                          </table>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Parfüm var mı?</label>
                            <select class="form-control" [(ngModel)]="parfume" [ngModelOptions]="{standalone: true}" (change)="checkParfume()">
                              <option value="0">Yok</option>
                              <option value="1">Var</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="parfume=='0'; else digerDurum">
                        <div class="row">
                          <div class="col-md-12">
                            <p>Bitmiş ürün formülasyonunda parfüm veya aroma bileşeni bulunmadığından, IFRA kapsamına
                              giren herhangi bir değerlendirme yapılmamıştır.</p>
                          </div>
                        </div>
                      </div>

                      <ng-template #digerDurum>
                        <div class="row">
                            <div class="col-md-3">
                            <div class="form-group">
                            <label>Alerjen</label>
                            <ng-template #rt3 let-r="result" let-t="term">

                              <ngb-highlight [result]="r.inciName" [term]="t"></ngb-highlight>
                            </ng-template>
                            <input id="typeahead-http3" type="text" class="form-control"
                              [class.is-invalid]="searchFailed3" [(ngModel)]="madde3" [ngbTypeahead]="search3"
                              [resultTemplate]="rt3" placeholder="Alerjen ara" [inputFormatter]="formatter3"
                              [ngModelOptions]="{standalone: true}" />
                          </div>
                          </div>
                          <div class="col-md-3">
                         <div class="form-group">
                            <label>% Concentration in the Parfum</label>
                             <input type="text" class="form-control" [(ngModel)]="pc" name="pc"
                                      id="pc" [ngModelOptions]="{standalone: true}">
                          </div> </div>
                           <div class="col-md-3 mt-1">
                            <button class="btn btn-primary" (click)="addAllergen()">Ekle</button>
                        </div>
                        </div>
                        <div class="row">

                        
                          <div class="col-md-12">
                            <h3><b>Alerjenler</b></h3>

                            <div class="row">
                              <div class="col-md-12">
                                <table class="table table-bordered">

                                  <thead>
                                    <tr>
                                      <th>Inci Adı</th>
                                      <th>CAS</th>
                                      <th>EINECS</th>
                                      <th>% Concentration in the Parfum</th>
                                      <th>% Concentration in the Finished Product</th>
                                      <th>İşlemler</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let a of allergenes;index as i">
                                      <td>
                                        {{a.madde.inciName}}
                                      </td>
                                        <td>
                                        {{a.madde.cas}}
                                      </td>
                                        <td>
                                        {{a.madde.einecs}}
                                      </td>
                                        <td>
                                        {{a.pc}}
                                      </td>
                                        <td>
                                        {{a.fc}}
                                      </td>
                                        <td>
                                      <i class="fa fa-remove danger" (click)="removeAllergen(i)"></i>
                                      </td>

                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                             
                            </div>
                            
                           

                          </div>
                        </div>

                        <div class="row mt-1">
                          <div class="col-md-12">
                            <h3><b>IFRA Değerlendirmesi <a class="btn btn-success"
                              (click)="addIfra()"> Ekle</a></b></h3>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <div class="row">
                                <div class="col-md-2">
                                  Parfüm Adı 
                                </div>
                                <div class="col-md-2">
                                  51. IFRA Amendment’e göre Kategorisi
                                </div>
                                <div class="col-md-2">
                                  % Parfümün Maksimum Kullanılabilir Konsantrasyon
                                </div>
                                <div class="col-md-2">
                                  Parfümün Bitmiş üründeki % Konsantrasyon
                                </div>
                                <div class="col-md-2">
                                  Uygunluk
                                </div>
                                <div class="col-md-2">
                                  
                                </div>
                              </div>

                              <div formArrayName="ifras"
                                *ngFor="let dep of getIfra().controls;let i=index">
                                <div class="row mt-1" [formGroupName]="i">
                                  <div class="col-md-2">
                                    <input type="text" class="form-control" formControlName="name" name="name"
                                      id="{{i}}name">
                                  </div>
                                  <div class="col-md-2">
                                    <input type="text" class="form-control" formControlName="category" name="category"
                                      id="{{i}}category">
                                  </div>
                                  <div class="col-md-2">
                                    <input type="text" class="form-control" formControlName="mc" name="mc"
                                      id="{{i}}mc">
                                  </div>
                                  <div class="col-md-2">
                                    <input type="text" class="form-control" formControlName="bc" name="bc"
                                      id="{{i}}bc">
                                  </div>
                                  <div class="col-md-2">
                                    <input type="text" class="form-control" formControlName="suitable" name="suitable"
                                      id="{{i}}suitable">
                                  </div>
                                  <div class="col-md-1">
                                    <i class="la la-trash danger cursor mt-1" (click)="removeIfra(i)">
    
                                    </i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>


                      </ng-template>

                      <div class="row mt-5">
                        <div class="col-md-12">
                          <h3><b>EC 1223/2009 Regülasyonu ve 5324 Kozmetik Kanunu’na göre hammadde sınırlama
                              kontrolü <button class="btn btn-success" (click)="checkAnnex()">Kontrol et</button></b></h3>
                        </div>
                      </div>

                      <div class="row mt-1">
                        <div class="col-md-12">
                         <table class="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                Hammaddenin INCI Adı
                              </th>
                              <th>
                                Ürün Tipi
                              </th>
                              <th>
                                Kullanılabilir Max. Konsantrasyonu
                              </th>
                              <th>
                                Diğer
                              </th>
                              <th>
                                Kullanım Şartları, Uyarı İfadeleri
                              </th>
                              <th>
                                Bitmiş Üründeki Madde Konsantrasyonu
                              </th>
                              <th>
                                Uygunluk
                              </th>
                              <th>Ek No</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let a of annex;index as i">
                              <td>{{a.inciName}}</td>
                              <td>{{a.productTypes}}</td>
                              <td>{{a.maxConsantrasyon}}</td>
                              <td>{{a.other}}</td>
                              <td>{{a.usagePurpose}}</td>
                              <td>{{a.bu}}</td>
                              <td>{{a.suitable}} <i class="fa fa-edit primary" (click)="editSuitable(i)"></i></td>
                              <td>{{a.annex}}</td>
                            </tr>
                          </tbody>
                         </table>
                        </div>
                      </div>


                      <div class="row mt-5">
                        <div class="col-md-12">
                          <h3><b>
                              2) Kozmetik ürünün fiziksel/kimyasal özellikleri ve stabilitesi
                            </b></h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <h3><b>
                              a) Madde veya karışımların fiziksel ve kimyasal özellikleri  <i class="fa fa-edit danger" (click)="hidea2()"></i>
                            </b>  </h3>
                        </div>
                      </div>

                      <div class="row" *ngIf="a2; else a2hide">
                        <div class="col-md-12">
                          <div class="form-group">
                            
                            <ngx-editor-menu [editor]="editor2a" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editor2a" formControlName="a2">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>

                      <ng-template #a2hide>
                      <div class="row" *ngFor="let c of compounds">
                        <div class="col-md-12 text-center">
                          <h5><b> {{c.madde.name}}</b></h5>
                          <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th>
                                  Parametre
                                </th>
                                <th>
                                  Metot
                                </th>
                                <th>
                                  Spesifikasyon
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let p of c.madde.properties">
                                <td>{{p.property}}</td>
                                <td>{{p.method}}</td>
                                <td>{{p.value}}</td>
                              </tr>
                            </tbody>

                          </table>
                        </div>
                      </div>
 </ng-template>


                      <div class="row">
                        <div class="col-md-12">
                          <h3><b>
                              b) Bitmiş kozmetik ürünün fiziksel ve kimyasal özellikleri<a class="btn btn-success"
                                (click)="addProjectDutyPerson('')">Ekle</a>
                            </b></h3>
                        </div>
                      </div>


                      <div class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-4">
                              Parametre
                            </div>
                            <div class="col-md-4">
                              Metot
                            </div>
                            <div class="col-md-4">
                              Spesifikasyon
                            </div>
                          </div>

                        <div class="form-group">

                          <div formArrayName="properties"
                            *ngFor="let dep of getProjectDutyPerson().controls;let i=index">
                            <div class="row mt-1" [formGroupName]="i">
                              <div class="col-md-4">
                                <input type="text" class="form-control" formControlName="property" name="property"
                                  id="{{i}}property">
                              </div>
                              <div class="col-md-4">
                                <input type="text" class="form-control" formControlName="method" name="method"
                                  id="{{i}}method">
                              </div>
                              <div class="col-md-3">
                                <input type="text" class="form-control" formControlName="value" name="value"
                                  id="{{i}}value">
                              </div>

                              <div class="col-md-1">
                                <i class="la la-trash danger cursor mt-1" (click)="removeDuty(i)">

                                </i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <h3><b>c)	Kozmetik ürünün stabilitesi</b></h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                              <label>Ürün Test Sıcaklıkları</label>
                                <input type="text" class="form-control" formControlName="heat">
                            </div>
                        </div>

                        <div class="col-md-8">
                          <div class="form-group">
                            <label>Ürün Kontrol Parametreleri</label>
                              <input type="text" class="form-control" formControlName="params">
                          </div>
                      </div>

                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            
                            <ngx-editor-menu [editor]="editor3" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editor3" formControlName="stability">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                         <h3><b>- Uygulanabilir olduğunda, açıldıktan sonra kullanım süresi ve gerekçesi.</b></h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            
                            <ngx-editor-menu [editor]="editor4" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editor4" formControlName="bestbefore">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <h3><b>3)	Mikrobiyolojik Kalite </b> <span><i class="la la-edit success" (click)="editMikro()"></i></span></h3>
                        </div>
                      </div>

                      <div *ngIf="showmikro; else mikrodurum">
                        <div class="row">
                          <div class="col-md-12">
                           
                          </div>
                        </div>
                      </div>

                      <ng-template #mikrodurum>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                            
                              <ngx-editor-menu [editor]="editormikro" [toolbar]="toolbar">
                              </ngx-editor-menu>
                              <ngx-editor [editor]="editormikro" formControlName="mikro">
                              </ngx-editor>
                            </div>
                          </div>
                        </div>
                       </ng-template>


                       <div class="row">
                        <div class="col-md-12">
                          <h3><b>4)	Safsızlıklar, kalıntılar, ambalaj materyali hakkında bilgi </b> <span><i class="la la-edit success" (click)="editSaf()"></i></span></h3>
                        </div>
                      </div>

                      <div *ngIf="showsaf; else safdurum">
                        <div class="row">
                          <div class="col-md-12">
                           
                          </div>
                        </div>
                      </div>

                      <ng-template #safdurum>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                            
                              <ngx-editor-menu [editor]="editorsaf" [toolbar]="toolbar">
                              </ngx-editor-menu>
                              <ngx-editor [editor]="editorsaf" formControlName="saf">
                              </ngx-editor>
                            </div>
                          </div>
                        </div>
                       </ng-template>


                       <div class="row" *ngFor="let c of compounds">
                        <div class="col-md-12">
                         <table class="table table-bordered">
                          <thead>
                            <tr >
                              <th colspan="3">
                                {{c.name}}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let s of c.pureness">
                              <td>
                                  {{s.name}}
                              </td>
                              <td>
                                {{s.limit}}
                              </td>
                              <td>
                                {{s.spesification}}
                              </td>
                            </tr>
                          </tbody>
                         </table>
                        </div>
                      </div>


                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                          
                            <ngx-editor-menu [editor]="editorsafdevam" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editorsafdevam" formControlName="safdevam">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <h3><b>Şişe</b></h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-3">
                         <div class="form-group">
                          <label>Ürün</label>
                          <input type="text" class="form-control" formControlName="bottleName">
                         </div>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                           <label>Materyal</label>
                           <input type="text" class="form-control" formControlName="bottleMaterial">
                          </div>
                         </div>

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>Renk</label>
                           <input type="text" class="form-control" formControlName="bottleColor">
                          </div>
                         </div>

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>Hacim</label>
                           <input type="text" class="form-control" formControlName="bottleVolume">
                          </div>
                         </div>

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>Toplam Yükseklik</label>
                           <input type="text" class="form-control" formControlName="bottleHeight">
                          </div>
                         </div>

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>Çap</label>
                           <input type="text" class="form-control" formControlName="bottleDiameter">
                          </div>
                         </div>

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>Genişlik</label>
                           <input type="text" class="form-control" formControlName="bottleWidth">
                          </div>
                         </div>
                      </div>


                      
                      <div class="row">
                        <div class="col-md-12">
                          <h3><b>Kapak</b></h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-3">
                         <div class="form-group">
                          <label>Ürün</label>
                          <input type="text" class="form-control" formControlName="lidName">
                         </div>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                           <label>Materyal</label>
                           <input type="text" class="form-control" formControlName="lidMaterial">
                          </div>
                         </div>

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>Renk</label>
                           <input type="text" class="form-control" formControlName="lidColor">
                          </div>
                         </div>

                       

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>Toplam Yükseklik</label>
                           <input type="text" class="form-control" formControlName="lidHeight">
                          </div>
                         </div>

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>Çap</label>
                           <input type="text" class="form-control" formControlName="lidDiameter">
                          </div>
                         </div>

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>Genişlik</label>
                           <input type="text" class="form-control" formControlName="lidWidth">
                          </div>
                         </div>

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>İç Çap</label>
                           <input type="text" class="form-control" formControlName="lidInDiameter">
                          </div>
                         </div>

                         <div class="col-md-3">
                          <div class="form-group">
                           <label>Üst Çap</label>
                           <input type="text" class="form-control" formControlName="lidUpDiameter">
                          </div>
                         </div>
                      </div>



                      <div class="row">
                        <div class="col-md-12">
                          <h3><b>5)	Normal ve makul olarak öngörülebilir kullanım</b></h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                          
                            <ngx-editor-menu [editor]="editorusage" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editorusage" formControlName="usage">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>


                      <div class="row mt-5">
                        <div class="col-md-12">
                          <h3><b>6)	Kozmetik ürüne maruziyet</b></h3>
                        </div>
                      </div>

                      <div class="row">
                
                      </div>


                      <div class="row mt-5">
                        <div class="col-md-12">
                          <h3><b>7)	Formülde yer alan maddelere maruziyet değerlendirmesi</b></h3>
                        </div>
                      </div>
                      
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                          
                            <ngx-editor-menu [editor]="editordegerlendirme" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editordegerlendirme" formControlName="degerlendirme">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>


                      <div class="row mt-5">
                        <div class="col-md-12">
                          <button class="btn btn-primary" (click)="calculate()">SED Hesapla</button>
                          
                        </div>
                      </div>
                      <div class="row mt-5">
                        <div class="col-md-12">
                         <table class="table table-bordered">
                          <thead>
                            <tr>
                              <th>Hammadde INCI Adı</th>
                              <th>Bitmiş Üründeki Konsantrasyonu C (%)</th>
                              <th>Retansiyon Faktör(R)</th>
                              <th>Dermal Absorbsiyon DAp (%)</th>
                              <th>SED (mg/kg bw/day)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let s of sedData">
                                <td>{{s.name}}</td>
                                <td>{{s.concantration}}</td>
                                <td>{{s.rf}}</td>
                                <td>{{s.dp}}</td>
                                <td>{{s.sed}}</td>
                            </tr>
                          </tbody>
                         </table>
                        </div>
                      </div>



                      <div class="row mt-5">
                        <div class="col-md-12">
                          <h3><b>8)	Formülde yer alan maddelerin toksikolojik profili</b></h3>
                        </div>
                      </div>

                      <div class="row mt-1">
                        <div class="col-md-12">
                          <div class="form-group">
                          
                            <ngx-editor-menu [editor]="editorprofile" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editorprofile" formControlName="profile">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-5">
                        <div class="col-md-12">
                         <table class="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                Hammadde INCI Adı
                              </th>
                              <th>
                                SED (mg/kg bw/day)
                              </th>
                              <th>
                                NOAEL  (mg/kg bw/day)
                              </th>
                              <th>
                                MoS  (NOAEL/SED)
                              </th>
                              <th>
                                Güvenli yazısı
                              </th>
                              <th>
                               Referans
                              </th>

                            </tr>
                          </thead>

                          <tbody>
                            <tr *ngFor="let m of mosData">
                              <td>
                                  {{m.name}}
                              </td>
                              <td>
                                {{m.sed}}
                            </td>
                            <td>
                              {{m.noael}}
                          </td>
                          <td>
                            {{m.mos}}
                        </td>
                        <td>
                          {{m.print}}
                      </td>
                      <td>
                        {{m.reference}}
                    </td>
                            </tr>
                          </tbody>
                         </table>
                        </div>
                      </div>


                      <div class="row mt-5">
                        <div class="col-md-12">
                          <h3><b>Hammadde Toksikolojik Veri Çalışmaları</b></h3>
                        </div>
                      </div>

                      <div class="row mt-1">
                        <div class="col-md-12">
                          <table class="table table-bordered">
                            <tbody>
                              <ng-container *ngFor="let c of compounds">
                              <tr *ngFor="let m of c.madde.materials">
                                <td>
                                    {{m.material.inciName}}
                                </td>
                                <td>
                                <div [innerHTML]="m.material.toksicology"></div>
                                </td>
                              </tr>
                            </ng-container>

                              <ng-container *ngFor="let m of allergenes">
                              <tr>
                                    <td>
                                    {{m.madde.inciName}}
                                </td>
                                <td><div [innerHTML]="m.madde.toksicology"></div>
                                 
                                </td>
                                </tr>
                            </ng-container>

                            </tbody>
                          </table>
                          

                         
                        </div>
                      </div>

                      <div class="row mt-5">
                        <div class="col-md-12">
                          <h3><b>9)	İstenmeyen etkiler ve ciddi istenmeyen etkiler</b></h3>
                        </div>
                      </div>

                      <div class="row mt-1">
                        <div class="col-md-12">
                          <div class="form-group">
                          
                            <ngx-editor-menu [editor]="editora9" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editora9" formControlName="a9">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>


                      <div class="row mt-5">
                        <div class="col-md-12">
                          <h3><b>10)	Kozmetik Ürün Bilgisi </b></h3>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-md-12">
                          <div class="form-group">
                          
                            <ngx-editor-menu [editor]="editora10" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editora10" formControlName="a10">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-5">
                        <div class="col-md-12">
                          <h3><b>Kısım B: Kozmetik Ürün Güvenlilik Değerlendirmesi</b></h3>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-md-12">
                          <h3><b>1)	Değerlendirme sonucu, </b></h3>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-md-12">
                          <div class="form-group">
                          
                            <ngx-editor-menu [editor]="editorb1" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editorb1" formControlName="b1">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-md-12">
                          <h3><b>2)	Etiketlenmiş uyarılar ve kullanım talimatları, </b></h3>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-md-12">
                          <div class="form-group">
                          
                            <ngx-editor-menu [editor]="editorb2" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editorb2" formControlName="b2">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-md-12">
                          <h3><b>3)	Gerekçelendirme,</b></h3>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-md-12">
                          <div class="form-group">
                          
                            <ngx-editor-menu [editor]="editorb3" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editorb3" formControlName="b3">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-md-12">
                          <h3><b>4)	Güvenlilik değerlendirme sorumlusunun referans mektubu ve nihai onayı.</b></h3>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-md-12">
                          <div class="form-group">
                          
                            <ngx-editor-menu [editor]="editorb4" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editorb4" formControlName="b4">
                            </ngx-editor>
                          </div>
                        </div>
                      </div>



                      <button (click)="save()" class="btn btn-danger">Kaydet</button>

                    </form>

                  </div>

                </div>


              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>